import React from 'react';
import '../assets/styles/style.css';

export const Preloader = () => {
    const name = "USHAN MIHIRANGA";
    
    return (
        <div className="preloader">
            {/* Background elements */}
            <div className="aurora-bg-glow"></div>
            
            <div className="content-wrapper">
                {/* Modern Organic Morphing Blob (using SVG Gooey filter) */}
                <div className="blob-container">
                    <div className="blob blob-1"></div>
                    <div className="blob blob-2"></div>
                    <div className="blob blob-3"></div>
                    <div className="blob-center"></div>
                </div>

                {/* Staggered text presentation */}
                <div className="text-container">
                    <h1 className="cinematic-text" aria-label={name}>
                        {name.split("").map((char, index) => (
                            <span 
                                key={index} 
                                className="char" 
                                style={{ '--char-index': index }}
                            >
                                {char === " " ? "\u00A0" : char}
                            </span>
                        ))}
                    </h1>
                    <div className="loading-bar-wrapper">
                        <div className="loading-bar-fill"></div>
                    </div>
                </div>
            </div>

            {/* SVG filter for the organic gooey effect */}
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ display: 'none' }}>
                <defs>
                    <filter id="gooey">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="12" result="blur" />
                        <feColorMatrix 
                            in="blur" 
                            mode="matrix" 
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -9" 
                            result="gooey" 
                        />
                        <feBlend in="SourceGraphic" in2="gooey" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};

